
import { Component } from '@angular/core';
import { ToastService } from '@app/core/services/toast/toast.service';

@Component({
    selector: 'cb-toasts',
    templateUrl: './toasts.component.html',
    styleUrls: ['./toasts.component.scss'],
    standalone: false
})
export class ToastsComponent {
    constructor(
        public toastService: ToastService
    ) {
    }
}
